module.exports = __webpack_public_path__ + "img/JavaScript32.12342171.svg";